import React from 'react';

const SHORTCUTS = [
  { category: 'Navigation', items: [
    { keys: ['Cmd', 'K'], description: 'Open command palette' },
    { keys: ['Cmd', 'N'], description: 'New proposal' },
  ]},
  { category: 'Actions', items: [
    { keys: ['Cmd', 'S'], description: 'Save draft' },
    { keys: ['Esc'], description: 'Close modal / panel' },
  ]},
  { category: 'Help', items: [
    { keys: ['F1'], description: 'Open Help Center' },
    { keys: ['Cmd', '/'], description: 'Open Help Center' },
    { keys: ['?'], description: 'Show this help' },
  ]},
];

export default function KeyboardShortcuts({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="shortcuts-overlay" onClick={onClose}>
      <div className="shortcuts-panel" onClick={e => e.stopPropagation()}>
        <h2>Keyboard Shortcuts</h2>
        {SHORTCUTS.map(group => (
          <div key={group.category}>
            <h3>{group.category}</h3>
            {group.items.map((item, i) => (
              <div key={i} className="shortcut-row">
                <span className="shortcut-keys">
                  {item.keys.map((k, j) => (
                    <span key={j}><kbd>{k}</kbd>{j < item.keys.length - 1 ? ' + ' : ''}</span>
                  ))}
                </span>
                <span className="shortcut-desc">{item.description}</span>
              </div>
            ))}
          </div>
        ))}
        <p style={{marginTop: 16, fontSize: 12, color: 'var(--text-muted)'}}>Press <kbd>?</kbd> or <kbd>Esc</kbd> to close</p>
      </div>
    </div>
  );
}
